module.exports = __webpack_public_path__ + "img/3DSis_uncheck.2277cfea.png";